import React from 'react';
import { ConfirmDeletePopupProps } from './types';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  isReactNative, NewLine,
  SimpleBlock,
  Text, TextInput,
  usePopupManager
} from 'ui-builder';
import { ClosePopupButton, Popup } from '../Popup';
import styles from './ConfirmPopup.module.scss';

export const ConfirmDeletePopupTestId = {
  popup: 'confirm-delete-popup',
  button: 'confirm-delete-popup-button',
}

export function ConfirmDeletePopup(props: ConfirmDeletePopupProps) {

  const [confirmationText, setConfirmationText] = React.useState<string>('');

  const popupManager = usePopupManager();

  const deleteFunc = async () => {
    await props.deleteFunc();
    popupManager.closePopup(true);
  };

  const messageCentered = props.messageCentered !== undefined ? props.messageCentered : true;

  return (
    <Popup
      title={props.title || 'Confirm Action'}
      content={(
        <SimpleBlock
          className={`${styles.message} ${messageCentered ? styles.centered : ''}`}
        >
          <Text>{props.message}</Text>
          {props.withConfirmationInput && (
            <>
              <NewLine />
              <NewLine />
              <TextInput
                source="confirmation"
                hideLabel
                placeholder={'Enter "DELETE" to enable "Confirm" button'}
                value={confirmationText}
                hint={confirmationText ? 'Enter "DELETE" to enable "Confirm" button' : undefined}
                onChangeCallback={(event) => {
                  setConfirmationText(event.confirmation);
                }}
              />
            </>
          )}
        </SimpleBlock>
      )}
      isCentered
      buttons={(
        <>
          <Button
            text="Confirm"
            variant={ButtonVariant.FILLED}
            onClick={deleteFunc}
            key="delete"
            color={ButtonColor.RED}
            isDisabled={props.withConfirmationInput && confirmationText !== 'DELETE'}
            size={isReactNative() ? ButtonSize.MEDIUM : ButtonSize.BIG}
            testId={ConfirmDeletePopupTestId.button}
          />
          <ClosePopupButton
            key="close"
            size={isReactNative() ? ButtonSize.MEDIUM : ButtonSize.BIG}
          color={ButtonColor.GRAY}
          />
        </>
      )}
      testId={props.testId || ConfirmDeletePopupTestId.popup}
    />
  );

}
